import {UAParser} from 'ua-parser-js';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { getTabId } from './getTabId';

export const getWebDeviceInfo = async () => {
  const parser = new UAParser();
  const ua = parser.getResult();
  const tabId = getTabId();
  const fp = await FingerprintJS.load();
  const fingerprint = (await fp.get()).visitorId;

  const browserName = ua.browser.name || 'UnknownBrowser';
  const os = ua.os.name || 'UnknownOS';

  return {
    deviceId: `${browserName}-${fingerprint}-${tabId}`,
    deviceName: `${browserName} on ${os}`,
    platform: 'WEB',
    osVersion: ua.os.version || 'Unknown',
    appVersion: process.env.REACT_APP_VERSION || '0.0.0',
    deviceToken: fingerprint,
  };
};
